<template>
  <div class="wrapper">
    <ag-charts-vue :options="options"></ag-charts-vue>
  </div>
</template>

<script>
import { AgChartsVue } from 'ag-charts-vue';

export default {
  components: {
    'ag-charts-vue': AgChartsVue,
  },
  props: {
    red: {type: Number, default: 0},
    green: {type: Number, default: 0}
  },
  data: function () {
    return {
      options: null,
      customTheme: { 
        baseTheme: 'ag-default-dark',
        palette: {
          fills: ['#32a852', '#d93838'],
          strokes: ['black'],
        },
      },
      data: [
        { type: 'green', count: this.green},
        { type: 'red', count: this.red},
      ],
    };
  },
  created() {
    this.options = {
      theme: this.customTheme,
      data: this.data,
      series: [
        {
          type: 'pie',
          calloutLabelKey: 'type',
          fillOpacity: 0.9,
          strokeWidth: 0,
          angleKey: 'count',
          sectorLabelKey: 'count',
          calloutLabel: {
            enabled: false,
          },
          sectorLabel: {
            color: 'white',
            fontWeight: 'bold',
          },
          tooltip: {
            enabled: false
          },
          innerRadiusRatio: 0.4,
          highlightStyle: {
            item: {
              fill: 'rgba(238, 238, 238, 0.15)',
              stroke: 'transparent',
              strokeWidth: 4,
            },
            series: {
              dimOpacity: 0.2,
              strokeWidth: 2,
            },
          },
        },
      ],
      legend: {
        enabled: false
      },
      background: {
        fill: 'transparent',
      },
    };
  },
}
</script>

<style scoped>
  .wrapper {
    width: 180px;
    height: 180px;
  }

</style>